/* VOXMEN motion layer for Shopify sections (GSAP + ScrollTrigger) */
(function () {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ready = () => {
    if (typeof gsap === 'undefined') return;
    if (typeof ScrollTrigger !== 'undefined') gsap.registerPlugin(ScrollTrigger);
    const hasST = typeof ScrollTrigger !== 'undefined';

    /* counters (always, even reduced motion → final value) */
    document.querySelectorAll('[data-vx-count]').forEach((el) => {
      const target = +el.dataset.vxCount, suffix = el.dataset.vxSuffix || '';
      if (reduce || !hasST) { el.textContent = target + suffix; return; }
      const obj = { v: 0 };
      ScrollTrigger.create({ trigger: el, start: 'top 85%', once: true, onEnter: () => gsap.to(obj, { v: target, duration: 1.4, ease: 'power2.out', onUpdate: () => { el.textContent = Math.round(obj.v) + suffix; } }) });
    });
    if (reduce) return;

    /* hero */
    document.querySelectorAll('[data-vx-hero]').forEach((hero) => {
      const lines = hero.querySelectorAll('.vx-line > span');
      const bottle = hero.querySelector('.vx-hero__bottle');
      const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });
      tl.from(lines, { yPercent: 110, duration: 1, stagger: 0.12 }, 0.1)
        .from(hero.querySelectorAll('.vx-reveal'), { y: 24, opacity: 0, duration: .8, stagger: .08 }, 0.5)
        .from(hero.querySelectorAll('.vx-hero__ring'), { scale: .6, opacity: 0, duration: 1.4, stagger: .1, ease: 'expo.out' }, 0);
      if (bottle) {
        tl.from(bottle, { y: 80, opacity: 0, scale: .9, duration: 1.3, ease: 'expo.out' }, 0.2);
        gsap.to(bottle, { y: -14, rotation: 1.5, duration: 3.2, ease: 'sine.inOut', yoyo: true, repeat: -1 });
      }
      tl.from(hero.querySelectorAll('.vx-pill'), { y: 20, opacity: 0, scale: .9, duration: .7, stagger: .12 }, 0.9);
      hero.querySelectorAll('.vx-pill').forEach((el, i) => gsap.to(el, { y: i % 2 ? 10 : -10, duration: 2.6 + i * .4, ease: 'sine.inOut', yoyo: true, repeat: -1, delay: i * .3 }));
      if (hasST) {
        gsap.to(hero.querySelector('.vx-hero__visual'), { yPercent: -12, scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
        gsap.to(hero.querySelectorAll('.vx-hero__ring'), { rotation: 40, scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: 1 } });
      }
      if (window.matchMedia('(pointer:fine)').matches) {
        hero.addEventListener('mousemove', (e) => {
          const r = hero.getBoundingClientRect();
          const x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
          if (bottle) gsap.to(bottle, { x: x * 18, rotationY: x * 6, rotationX: -y * 4, duration: .8, ease: 'power2.out', overwrite: 'auto' });
          gsap.to(hero.querySelector('.vx-hero__glow'), { x: x * 60, y: y * 40, duration: 1.2, ease: 'power2.out' });
          gsap.to(hero.querySelectorAll('.vx-pill'), { x: x * -12, y: y * -10, duration: 1, ease: 'power2.out' });
        });
      }
    });

    if (!hasST) return;
    /* generic reveals */
    document.querySelectorAll('.vx-section .vx-reveal').forEach((el) => {
      gsap.from(el, { y: 40, opacity: 0, duration: .9, ease: 'power3.out', scrollTrigger: { trigger: el, start: 'top 88%', once: true } });
    });
    document.querySelectorAll('[data-vx-stagger]').forEach((wrap) => {
      const items = wrap.children;
      gsap.from(items, { y: 40, opacity: 0, duration: .8, stagger: .1, ease: 'power3.out', scrollTrigger: { trigger: wrap, start: 'top 85%', once: true } });
    });
    document.querySelectorAll('[data-vx-parallax]').forEach((img) => {
      gsap.fromTo(img, { yPercent: -6 }, { yPercent: 6, ease: 'none', scrollTrigger: { trigger: img.parentElement, start: 'top bottom', end: 'bottom top', scrub: true } });
    });
    document.querySelectorAll('.vx-final__bg img').forEach((img) => {
      gsap.fromTo(img, { scale: 1.15 }, { scale: 1, ease: 'none', scrollTrigger: { trigger: img.closest('.vx-final'), start: 'top bottom', end: 'bottom top', scrub: true } });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
  // theme editor: re-run reveals when a section is (re)loaded
  document.addEventListener('shopify:section:load', () => { if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh(); });
})();
